'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const ProjectsIcon = createIcon({
    displayName: 'ProjectsIcon',
    viewBox: '0 0 20 20',
    fill: 'none',
    path: (
        <path
            d="M11.8 9.867H5.133m3.334 2.916H5.133M11.8 6.95H5.133m13.334 2.083V6.7c0-.933 0-1.4-.182-1.757a1.666 1.666 0 00-.728-.728c-.357-.182-.823-.182-1.757-.182H4.467c-.934 0-1.4 0-1.757.182-.314.16-.569.415-.728.728C1.8 5.3 1.8 5.767 1.8 6.7v6.333c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182h5.666m3.334-1.667l1.666 1.667 3.334-3.333"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default ProjectsIcon
